var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeedbackStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.9215 3.66006L36.0758 12.9364C36.782 14.2097 38.5546 15.4193 40.0121 15.5828L48.6881 16.6682C54.2432 17.3512 55.6757 21.2747 51.8952 25.3844L45.4543 32.3465C44.3791 33.5132 43.821 35.7391 44.253 37.2668L46.5097 45.4634C48.2848 51.9348 44.9091 54.6171 38.977 51.4385L30.6902 46.9973C29.1809 46.1854 26.7836 46.3035 25.3658 47.2151L17.4771 52.2968C11.8299 55.9291 8.23638 53.5379 9.47552 46.9491L11.0623 38.6106C11.3585 37.0519 10.6483 34.8768 9.47592 33.8067L2.4804 27.3965C-1.62466 23.6201 -0.520441 19.5952 4.94973 18.4541L13.4911 16.6785C14.9325 16.3668 16.603 15.0518 17.1895 13.7138L21.5655 4.03096C23.919 -1.19619 28.1387 -1.36049 30.9215 3.66006Z",
    fill: "#9CA3AF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedbackStar);
export default __webpack_public_path__ + "static/media/FeedbackStar.451a8a00d1c41be9d2fadd6caf5e1851.svg";
export { ForwardRef as ReactComponent };